var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#f05138",
    rx: 60
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m202.677 158.04l.724-2.896c10.616-42.224-15.201-92.41-59.114-118.71c19.302 26.058 27.747 57.666 20.267 85.172c-.724 2.413-1.448 4.826-2.413 7.239c-.965-.724-2.171-1.448-3.86-2.172c0 0-43.672-27.024-90.963-74.556c-1.207-1.206 25.334 37.881 55.253 69.489c-14.235-7.962-53.564-36.675-78.658-59.355c3.137 5.067 6.756 10.134 10.617 14.718c20.75 26.541 48.015 59.114 80.588 84.207c-22.922 13.995-55.254 15.201-87.344 0c-7.962-3.619-15.442-8.203-22.44-13.27c13.512 21.715 34.504 40.535 60.08 51.634c30.401 13.029 60.803 12.306 83.242.241c0 0 .241 0 .241-.241c.965-.482 1.931-1.206 2.896-1.689c10.857-5.549 32.09-11.099 43.672 11.099c3.378 5.067 9.41-23.887-12.788-50.91"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.eb5d6af45ffbc6c8cc19ad5709cfab18.svg";
export { ForwardRef as ReactComponent };